import React, { useCallback, useEffect, useState } from 'react'

const useSticky = (
  distanceFromTop: number,
  elementRef: React.RefObject<HTMLElement>
): boolean => {
  const [elementTop, setTop] = useState<number | null>(null)

  const onScroll = useCallback(() => {
    if (elementRef.current) {
      const scrollContainer = elementRef.current.closest('.overflow-scroll')
      if (scrollContainer) {
        const box = elementRef.current.getBoundingClientRect()
        const containerBox = scrollContainer.getBoundingClientRect()
        setTop(box.top - containerBox.top)
      }
    }
  }, [elementRef])

  useEffect(() => {
    const scrollContainer = elementRef.current?.closest('.overflow-scroll')
    if (scrollContainer) {
      scrollContainer.addEventListener('scroll', onScroll)
      return () => scrollContainer.removeEventListener('scroll', onScroll)
    }
  }, [elementRef, onScroll])

  return elementTop === null
    ? false
    : Math.trunc(elementTop ?? 0) === distanceFromTop
}

export default useSticky
